<template>
  <div class="mdc-dialog">
    <div class="mdc-dialog__container">
      <div class="mdc-dialog__surface">
        <h2 class="mdc-dialog__title">
          {{ $t('272') }}
          <!-- 프로필 유형 -->
        </h2>
        <div class="mdc-dialog__content pdt-24 pdb-16">
          <div class="d-flex align-items-center mdc-form-field pdt-6 pdb-6">
            <div class="mdc-radio mdc--radio__custom">
              <input aria-labelledby="theme-radios theme-dark-label" class="mdc-radio__native-control" name="themes"
                     tabindex="0" type="radio"
                     value="dark" @click="getProfilePicture('/member/profilePicture')" >
              <div class="mdc-radio__background">
                <div class="mdc-radio__outer-circle"></div>
                <div class="mdc-radio__inner-circle"></div>
              </div>
            </div>
            <label id="theme-dark-label" class="t-body1 pdl-22" for="theme-dark">{{ $t("273") }}</label>
          </div>
          <div class="d-flex align-items-center mdc-form-field  pdt-6 pdb-6">
            <div class="mdc-radio mdc--radio__custom">
              <input aria-labelledby="theme-radios theme-dark-label" class="mdc-radio__native-control" name="themes"
                     tabindex="0" type="radio"
                     value="dark" @click="getProfilePicture('/member/profilePatten')" >
              <div class="mdc-radio__background">
                <div class="mdc-radio__outer-circle"></div>
                <div class="mdc-radio__inner-circle"></div>
              </div>
            </div>
            <label id="theme-dark-label" class="t-body1 pdl-22" for="theme-dark"> {{ $t("275") }}</label>
          </div>
        </div>
        <footer class="mdc-dialog__actions">
          <button
              class="mdc-button mdc-dialog__button btn-white"
              data-mdc-dialog-action="no"
              type="button"
          >
							<span class="mdc-button__label t-color-secondaryBtnText">
								{{ $t('276') }}
                <!-- 닫기 -->
							</span>
          </button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import {MDCDialog} from "@material/dialog";
import {fileMixin} from "@/mixins/file";

export default {
  name: "ProfilePhotoType",

  mixins: [fileMixin],

  mounted() {
    this.pattenDialog = new MDCDialog(document.querySelector('.mdc-dialog'))
    this.pattenDialog.listen('MDCDialog:opened', () => {
    });
  },

  methods: {
    getProfilePicture(path) {
      this.$emit("closePattenDialog");
      this.$router.push(path)
    },

    openPattenDialog(path) {
      this.pattenDialog.open();
      this.$router.push(path);
    },
  }
}
</script>

<style scoped>

</style>